/**
 * 現場(サイト)APIサービス
 *
 * `GET /api/sites` は MCM/DEV のみアクセス可能(faro-api `requireMcmOrDevUser`)。
 * 発注ワークフローの現場選択肢構築等に使用する。
 */
import { apiClient } from '@/shared/lib/axios';
import { logger } from '@/shared/lib/logger';

/** 現場基本情報 */
export interface SiteBasicInfo {
  readonly id: number;
  readonly siteName: string;
}

interface GetAllSitesResponse {
  readonly success: boolean;
  readonly sites: readonly SiteBasicInfo[];
}

/**
 * 全現場一覧を取得(MCM/DEV のみ)
 */
export const getAllSites = async (): Promise<readonly SiteBasicInfo[]> => {
  try {
    const response = await apiClient.get<GetAllSitesResponse>('/api/sites');
    if (!response.data.success) {
      throw new Error('現場一覧の取得に失敗しました');
    }
    return response.data.sites;
  } catch (error) {
    logger.captureError(error, 'siteApiService.getAllSites');
    throw error;
  }
};
